/**
 * Converts markdown text to clean plain text for use in structured data
 * Removes markdown formatting while preserving the readable content
 * 
 * @param markdown - The markdown string to convert
 * @returns Clean plain text suitable for structured data
 */
export const markdownToText = (markdown: string): string => {
  if (!markdown) return '';
  
  return markdown
    // Remove markdown link syntax [text](url) but keep the link text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    // Remove bold/italic markers
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    .replace(/_([^_]+)_/g, '$1')
    // Remove code markers  
    .replace(/`([^`]+)`/g, '$1')
    // Remove heading markers
    .replace(/^#{1,6}\s+/gm, '')
    // Remove blockquote markers
    .replace(/^>\s+/gm, '')
    // Remove list markers but keep the content
    .replace(/^[\s]*[-*+]\s+/gm, '')
    .replace(/^[\s]*\d+\.\s+/gm, '')
    // Clean up multiple line breaks
    .replace(/\n\s*\n/g, '\n')
    .trim();
}; 